export default __webpack_public_path__ + "static/media/chat_logo_keto_rounded.c999f500.svg";